import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import AdminLayout from './AdminLayout';
import { api } from '../lib/api';
import { useToast } from './useToast';

export default function AdminChangePassword() {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);
  const [toast, showToast] = useToast();
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      showToast("New password and confirmation don't match.", 'error');
      return;
    }
    setSaving(true);
    try {
      await api.changePassword(form.currentPassword, form.newPassword);
      showToast('Password updated');
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminLayout title="Change Password">
      <form onSubmit={handleSubmit} className="admin-form" style={{ maxWidth: 380 }}>
        <div className="admin-form-group" style={{ position: 'relative' }}>
          <label>Current Password</label>
          <input
            type={showCurrent ? 'text' : 'password'}
            required
            value={form.currentPassword}
            onChange={e => setForm({ ...form, currentPassword: e.target.value })}
          />
          <button type="button" aria-label="Toggle current password visibility" onClick={() => setShowCurrent(s => !s)} style={{ position: 'absolute', right: 12, top: 36, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--burgundy)' }}>
            {showCurrent ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <div className="admin-form-group" style={{ position: 'relative' }}>
          <label>New Password</label>
          <input
            type={showNew ? 'text' : 'password'}
            required
            minLength={8}
            value={form.newPassword}
            onChange={e => setForm({ ...form, newPassword: e.target.value })}
          />
          <button type="button" aria-label="Toggle new password visibility" onClick={() => setShowNew(s => !s)} style={{ position: 'absolute', right: 12, top: 36, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--burgundy)' }}>
            {showNew ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <div className="admin-form-group" style={{ position: 'relative' }}>
          <label>Confirm New Password</label>
          <input
            type={showConfirm ? 'text' : 'password'}
            required
            minLength={8}
            value={form.confirmPassword}
            onChange={e => setForm({ ...form, confirmPassword: e.target.value })}
          />
          <button type="button" aria-label="Toggle confirm password visibility" onClick={() => setShowConfirm(s => !s)} style={{ position: 'absolute', right: 12, top: 36, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--burgundy)' }}>
            {showConfirm ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        <button type="submit" className="admin-btn admin-btn-primary" disabled={saving}>
          {saving ? 'Updating…' : 'Update Password'}
        </button>
      </form>
      {toast && <div className={`admin-toast ${toast.type === 'error' ? 'error' : ''}`}>{toast.message}</div>}
    </AdminLayout>
  );
}
